import ServiceError from '../domain/ServiceError.js';

class LinkAccountValidator {

  constructor(validatorUtils) {

    this.validatorUtils = validatorUtils;

  }

  validate(requestToken, emailAddress, askForEmailForRegister) {

    let fieldErrors = [];

    if (requestTokenIsEmpty(requestToken)) {
      fieldErrors.push({
        field: 'request_token',
        error_code: 25102
      });
    }

    if (askForEmailForRegister
      && !this.validatorUtils.emailAddressIsValid(emailAddress)) {
      fieldErrors.push({
        field: 'email_address',
        error_code: 25103
      });
    }

    if (fieldErrors.length > 0) {
      throw new ServiceError(400, {
        error_code: 25003,
        field_messages: fieldErrors
      });
    }

  }
  
}

let requestTokenIsEmpty = function (requestToken) {

  return requestToken === undefined
    || requestToken === null
    || requestToken === '';

};

export default LinkAccountValidator;



// WEBPACK FOOTER //
// ./src/library/validators/RegisterValidator.js